// import React, { useEffect } from "react";
// import { Select } from "antd";
// import { Modal } from "react-bootstrap";
// //css
// import "./Modal.css";
// import { Form } from "react-bootstrap";
// import BtnDelete from "../Commons/Buttons/BtnDelete";
// import BtnSave from "../Commons/Buttons/BtnSave";
// import TextArea from "../Commons/Forms/TextArea";
// import { getRole, getUser } from "../Helpers/Utilities/Common";

// const { Option } = Select;

// function AddToQueueModal(props) {
//   const role = getRole();
//   const userId = getUser();

//   useEffect(() => {
//     if (role !== "nurse") {
//       props.setSelectedDoctor(userId);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [role]);

//   return (
//     <div>
//       <Modal
//         show={props.show}
//         onHide={props.onHide}
//         backdrop="static"
//         keyboard={false}
//         size="md"
//         centered
//       >
//         <Modal.Body>
//           <div className="row">
//             <Form.Label className="form-title align-center">
//               Add to Queue
//             </Form.Label>
//           </div>
//           {/*if user is admin/resident, no need to select doctor.*/}
//           {role === "nurse" && (
//             <>
//               <div className="row mt-2">
//                 <span>
//                   Doctor <label className="red"> *</label>
//                 </span>
//                 <Select
//                   required
//                   placeholder="Select Doctor"
//                   onChange={props.setSelectedDoctor} // Directly update state
//                   value={props.selectedDoctor} // Use selected doctor
//                   allowClear
//                   options={props.doctorsData}
//                   optionFilterProp="label"
//                   showSearch
//                 />
//               </div>
//             </>
//           )}
//           <div className="row mt-1">
//             <TextArea
//               required={true}
//               name="complaint"
//               formLabel={`Chief Complaint`}
//               value={props?.complaint?.toUpperCase()}
//               onChange={props.onChange}
//             />
//           </div>

//           <div className="row mt-4 right">
//             <div className="col-6">
//               <BtnDelete
//                 label={"Close"}
//                 size={"sm"}
//                 onClick={props.onHide}
//                 isClicked={props.isClicked}
//               />
//             </div>
//             <div className="col-6">
//               <BtnSave
//                 label={"Add to Queue"}
//                 size={"sm"}
//                 onClick={props.onConfirm}
//                 isClicked={props.isClicked}
//                 disabled={props.complaint === "" || props.doctor_id === ""}
//               />
//             </div>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </div>
//   );
// }

// export default AddToQueueModal;

import { useEffect, useState } from "react";
import { Select } from "antd";
import { Modal, Form } from "react-bootstrap";
import "./Modal.css";
import BtnDelete from "../Commons/Buttons/BtnDelete";
import BtnSave from "../Commons/Buttons/BtnSave";
import { getPCPDoctors } from "../Helpers/API/DoctorApi/DoctorApi";

const { Option } = Select;

function AddToQueueModal(props) {
  const [pcpDoctors, setPcpDoctors] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [loading, setLoading] = useState(false);

  // Fetch PCP doctors when modal opens
  useEffect(() => {
    if (props.show) {
      fetchPCPDoctors();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  async function fetchPCPDoctors() {
    setLoading(true);
    const response = await getPCPDoctors();
    if (response?.data) {
      const onlyPCP = (Array.isArray(response.data.data) ? response.data.data : []).filter(
        (doctor) =>
          Array.isArray(doctor.specializations) &&
          doctor.specializations.some((s) => {
            const name = String(s?.name || "").toUpperCase();
            return name === "PRIMARY CARE PHYSICIANS" || name === "PCP";
          })
      );
      const mappedDoctors = onlyPCP.map((doctor) => ({
        label: doctor.doctor_name,
        value: doctor.id,
        id: doctor.id,
        master_doctor_id: doctor.master_doctor_id,
        doctor_name: doctor.doctor_name,
      }));
      setPcpDoctors(mappedDoctors);
    } else {
      setPcpDoctors([]);
    }
    setLoading(false);
  }

  function handleProceed() {
    const selectedDoctorData = pcpDoctors.find(doc => doc.id === selectedDoctor);
    props.onConfirm("proceed", selectedDoctor, selectedDoctorData?.master_doctor_id, selectedDoctorData?.doctor_name || "");
  }

  function handleNo() {
    props.onConfirm("no", null);
  }

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      backdrop="static"
      keyboard={false}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Add to Queue</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Label>Select PCP Doctor <label className="red">*</label></Form.Label>
          <Select
            placeholder="Select Doctor"
            showSearch
            size="large"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            value={selectedDoctor}
            onChange={(value) => setSelectedDoctor(value)}
            loading={loading}
            disabled={props.isClicked}
            style={{ width: "100%" }}
            getPopupContainer={(trigger) => trigger.parentElement} 
          >
            {pcpDoctors.map((doctor) => (
              <Option key={doctor.id} value={doctor.value}>
                {doctor.label}
              </Option>
            ))}
          </Select>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <BtnDelete
          label="Cancel"
          size="sm"
          onClick={props.onHide}
          isClicked={props.isClicked}
          disabled={props.isClicked}
        />
        <BtnSave
          label="Proceed"
          size="sm"
          onClick={handleProceed}
          isClicked={props.isClicked}
          disabled={!selectedDoctor || props.isClicked}
        />
      </Modal.Footer>
    </Modal>
  );
}

export default AddToQueueModal;
